import PropTypes from "prop-types";
import React from "react";

/**
 * Componente de cabecera de página.
 * Solo muestra el título — pero como aparece en TODAS las pantallas,
 * conviene que use los tokens semánticos para que el modo oscuro
 * funcione sin sorpresas.
 */
const Breadcrumb = ({ pageName }) => {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h2 className="text-title-md1 font-semibold text-text-default dark:text-dark-text-default">
        {pageName}
      </h2>
    </div>
  );
};

Breadcrumb.propTypes = {
  pageName: PropTypes.string.isRequired,
};

export default Breadcrumb;
